var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PSection',{attrs:{"wari-wari-game-info":"","theme":"white"}},[_c('div',{staticClass:"contents-holder"},[_c('div',{staticClass:"left-holder"},[_c('WildRiftRewards')],1),_c('div',{staticClass:"right-holder"},[_c('WildRiftResult')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }